<onboarding-container
  [formValid]="isFormValid$ | async"
  [loading]="facade.sendingPersonalInformation$ | async"
  (back)="facade.goToPreviousStep()"
  (forward)="submit()"
>
  <p class="zero-text p-huge-med">{{ 'onboarding.person.headline' | transloco }}</p>
  <p class="zero-text p-base-reg">{{ 'onboarding.person.text' | transloco }}</p>
  <div class="d-flex gap">
    @for (gender of genders; track $index) {
      <div
        data-zid="salutation"
        class="gender px-3 py-2 zero-surface grey-800 cursor-pointer b-r-4 zero-text p-base-reg"
        [ngClass]="{
          'primary-400 btn': (gender$ | async) === gender,
          error: displayMissingGenderError$ | async,
        }"
        (click)="toggleGender(gender)"
      >
        {{ 'onboarding.person.genders.' + gender | transloco }}
      </div>
    }
  </div>
  <web-design-system-input
    class="d-block mt-4"
    [value]="name$ | async"
    [isValid]="name$ | async | notEmpty"
    [label]="'onboarding.person.name' | transloco"
    (valueChange)="handleNameChange($event)"
    data-zid="first-name"
  />
  <web-design-system-input
    class="d-block mt-4"
    [value]="lastName$ | async"
    [isValid]="lastName$ | async | notEmpty"
    [label]="'onboarding.person.lastName' | transloco"
    (valueChange)="handleLastNameChange($event)"
    data-zid="last-name"
  />
  <p class="mt-4 zero-text label p-small-reg" (click)="openPepModal(pepModal)" [innerHTML]="'onboarding.person.pep.label' | transloco"></p>

  <p class="zero-text p-huge-med mt-5">{{ 'onboarding.person.headline2' | transloco }}</p>
  <div class="d-flex gap justify-content-between">
    <web-design-system-input
      type="number"
      labelSize="small"
      [value]="birthDay$ | async"
      [isValid]="birthDay$ | async | day: (birthMonth$ | async) : (birthYear$ | async)"
      [label]="'onboarding.person.birthDay' | transloco"
      (valueChange)="handleBirthDayChange($event)"
      data-zid="birth-day"
    />
    <web-design-system-input
      type="number"
      labelSize="small"
      [value]="birthMonth$ | async"
      [isValid]="birthMonth$ | async | month: (birthDay$ | async) : (birthYear$ | async)"
      [label]="'onboarding.person.birthMonth' | transloco"
      [focus]="(focussedField$ | async) === 'birthMonth'"
      (valueChange)="handleBirthMonthChange($event)"
      data-zid="birth-month"
    />
    <web-design-system-input
      type="number"
      labelSize="small"
      [value]="birthYear$ | async"
      [isValid]="birthYear$ | async | year: (birthDay$ | async) : (birthMonth$ | async)"
      [label]="'onboarding.person.birthYear' | transloco"
      [focus]="(focussedField$ | async) === 'birthYear'"
      (valueChange)="handleBirthYearChange($event)"
      data-zid="birth-year"
    />
  </div>
  @if (birthdateError$ | async; as errorType) {
    @if (('onboarding.person.birth-date-error.' + errorType | transloco) !== 'onboarding.person.birth-date-error.' + errorType) {
      <p class="zero-text course-red p-small-reg mt-2">{{ 'onboarding.person.birth-date-error.' + errorType | transloco }}</p>
    }
  }
  <web-design-system-select
    class="d-block mt-4"
    [items]="countries$ | async"
    [placeholder]="'onboarding.person.country' | transloco"
    (selectItem)="selectCountry($event)"
    data-zid="birth-land"
  />
  <web-design-system-input
    class="d-block mt-4"
    [value]="city$ | async"
    [isValid]="city$ | async | notEmpty"
    [label]="'onboarding.person.city' | transloco"
    (valueChange)="handleCityChange($event)"
    data-zid="birth-place"
  />
  @if (displayPromoCodeFunctionality) {
    <p class="mt-4">
      @if (!displayPromoCodeForm) {
        <a class="zero-text p-small-reg label cursor-pointer" data-zid="promo-link" (click)="displayPromoCodeForm = true">
          {{ 'onboarding.person.promoCodeLink' | transloco }}
        </a>
      } @else {
        <web-design-system-input
          [value]="promoCode$ | async"
          [isValid]="promoCodeValid$ | async"
          [label]="'onboarding.person.promoCode' | transloco"
          [error]="hasPromoCodeError ? ('onboarding.person.promoCodeError' | transloco) : null"
          [disabled]="promoCodeDisabled$ | async"
          (valueChange)="handlePromoCodeChange($event)"
        />
      }
    </p>
  }
</onboarding-container>

<ng-template #pepModal let-modal>
  <web-design-system-modal [headline]="'onboarding.person.pep.headline' | transloco" (dismiss)="modal.dismiss('Cross click')">
    <p class="zero-text p-base-reg" [innerHTML]="'onboarding.person.pep.text' | transloco"></p>
    <textarea
      class="d-block mt-4"
      [attr.maxlength]="pepReasonMaxLength"
      [value]="pepReason$ | async"
      (input)="handlePepReasonChange($event)"
      [placeholder]="'onboarding.person.pep.placeholder' | transloco"
    ></textarea>
    <div class="zero-text p-xsmall-reg d-flex justify-content-end">{{ (pepReason$ | async)?.length ?? 0 }}/{{ pepReasonMaxLength }}</div>
    <div class="d-flex mt-4 justify-content-end">
      <web-design-system-button size="small" (click)="modal.dismiss('Close')">
        {{ 'onboarding.person.pep.btn' | transloco }}
      </web-design-system-button>
    </div>
  </web-design-system-modal>
</ng-template>
